export default "__VITE_ASSET__h9POl0ux__"